import { a as getValueByKey } from "../utils/value-by-key-dde48741.mjs";
const useSelectableListProps = {
  options: { type: Array, default: () => [] },
  textBy: { type: [String, Function], default: "text" },
  valueBy: { type: [String, Function], default: "" },
  trackBy: { type: [String, Function], default: "" },
  disabledBy: { type: [String, Function], default: "disabled" },
  groupBy: { type: [String, Function], default: "group" }
};
function useSelectableList(props) {
  const getOptionProperty = (option, prop) => {
    if (typeof option !== "object") {
      return option;
    }
    return getValueByKey(option, prop);
  };
  const getTrackBy = (option) => {
    return props.trackBy ? getOptionProperty(option, props.trackBy) : getValue(option);
  };
  const getDisabled = (option) => {
    if (typeof option !== "object") {
      return false;
    }
    return getOptionProperty(option, props.disabledBy);
  };
  const getText = (option) => {
    const optionText = getOptionProperty(option, props.textBy);
    if (["number", "boolean"].includes(typeof optionText)) {
      return String(optionText);
    }
    return optionText;
  };
  const getGroupBy = (option) => {
    if (!option || typeof option !== "object") {
      return void 0;
    }
    return getOptionProperty(option, props.groupBy);
  };
  const getValue = (option) => getOptionProperty(option, props.valueBy);
  return {
    getValue,
    getText,
    getDisabled,
    getTrackBy,
    getGroupBy
  };
}
export {
  useSelectableList as a,
  useSelectableListProps as u
};
//# sourceMappingURL=useSelectableList-db4344e1.mjs.map
